import { dayNamesShort, monthNamesFull } from "./date-settings";
import { COUNTRY_CODE, REGION_CODE, LANG, BUSINESS_LANDING } from './constants';
import { getIndex, getStateDataByStateId, getCountryNameByCountryCode, capitalizeText } from "../utils/utility";
import  AppConfigData from './app-config.json';
import { isValid, format } from 'date-fns';
import { addressFormMatrix } from "./form-fields-matrix";
import { orderDissection } from "./order-dissection";
import drsTableDataTransform from "./device-recovery-services/tables-configuration/data-transformation";

export const transformMaterialsData = (data, orderType) => {
    if (!data.list || !orderType) return null;

    const result = [];
    const orderOptions = AppConfigData.order_options[orderType];
    const allowedLimitData = orderOptions.limits_per_order[REGION_CODE] || null;
    let requiresWeight = [];//(orderOptions.weight_required_for && REGION_CODE === "AMS") || [];
    if (REGION_CODE === "AMS" && orderOptions.weight_required_for && orderOptions.weight_required_for.length) {
        requiresWeight = orderOptions.weight_required_for;
    }

    data.list.forEach(material => {
        const parentMaterialId = material.materialFamily;
        //const defaultQtyData = data.defaultQuantities.filter(m => m.materialLongDesc === material.materialLongDesc);

        const currentMaterialData = {
            id: material.materialCode,
            label: material.materialLongDesc,
            name: material.materialName,
            maxLimit: material.maxLimit,
            title: material.materialFamilyDesc,
            description: material.description,
            quantity: material.quantity || 0,
            serviceType: material.serviceType || 0,
            family: material.materialSubFamily || "",
            ...(requiresWeight.indexOf(parentMaterialId) !== -1) && {
                weight: 0
            }
            //quantity: (defaultQtyData.length && defaultQtyData[0].value) || 0
        }

        const resultIndex = getIndex(result, "id", parentMaterialId);
        const maxPerOrder = allowedLimitData && allowedLimitData[parentMaterialId] ? allowedLimitData[parentMaterialId] : material.maxLimit;

        if (resultIndex === -1) {
            result.push({
                id: parentMaterialId,
                title: material.materialFamilyDesc,
                description: material.description,
                materials: [currentMaterialData],
                boxService: material.serviceType && REGION_CODE === "EMEA" ? true : false,
                ...(maxPerOrder) && {
                    maxPerOrder: maxPerOrder
                }
            });
        }
        else {
            result[resultIndex].materials.push(currentMaterialData);
        }
    });

    return result;
}

export const transformBoxServicesMaterialsData = data => {
    let result = [];

    data.forEach((material, i) => {
        const id = material.id;
        const family = material.family;
        const title = material.title;
        const typeId = id.split("_")[0];
        const familyIndex = getIndex(result, "id", family);

        const type = {
            id: typeId,
            name: material.name,
            description: material.description,
            materials: [material]
        }

        if (familyIndex === -1) {
            let types = [];
            types.push(type);

            result.push({
                id: family,
                title: title,
                types: types
            });

        }
        else {
            const typesIndex = getIndex(result[familyIndex].types, "id", typeId);
            let types = [...result[familyIndex].types];

            if (typesIndex === -1) {
                types.push(type);
            }
            else {
                const materialIndex = getIndex(result[familyIndex].types[typesIndex].materials, "id", id);
                let materials = [...result[familyIndex].types[typesIndex].materials];

                if (materialIndex === -1) {
                    materials.push(material)
                }

                result[familyIndex].types[typesIndex].materials = materials;
            }

            result[familyIndex].types = types;
        }
    })

    return result;
}

export const groupMultiFamilyMaterialDataByServiceType = data => {
    let result = [];
    data.forEach(familyType => {
        familyType.materials.forEach(material => {
            const serviceType = material.serviceType;
            const serviceTypeIndex = getIndex(result, "serviceType", serviceType);

            if (serviceTypeIndex === -1) {
                result.push({
                    serviceType: serviceType,
                    materials: [material]
                });
            }
            else {
                result[serviceTypeIndex].materials.push(material);
            }
        });
    });

    return result;
}

export const groupMaterialDataByServiceType = data => {
    if (data.length > 1) return groupMultiFamilyMaterialDataByServiceType(data);

    let result = [];

    data[0].materials.forEach(material => {
        const serviceType = material.serviceType;
        const serviceTypeIndex = getIndex(result, "serviceType", serviceType);

        if (serviceTypeIndex === -1) {
            result.push({
                serviceType: serviceType,
                materials: [material]
            });
        }
        else {
            result[serviceTypeIndex].materials.push(material);
        }
    })
    return result;
}

export const transformFaqData = (categories) => {
    let questions = [];
    for (let category in categories) {
        for (let question in categories[category].questions) {
            let ques = { ...categories[category].questions[question] };
            ques.categoryId = categories[category].faqCategoryId;
            questions.push(ques);
        }
    }
    return questions;
}

export const filterQuestions = (categories, str) => {
    let matchingCategories = {};
    for (let category in categories) {
        matchingCategories[categories[category].faqCategoryId] = []
        for (let question in categories[category].questions) {
            if (categories[category].questions[question].question.toLowerCase().indexOf(str.toLowerCase()) > -1)
                matchingCategories[categories[category].faqCategoryId].push(categories[category].questions[question])
        }
        if (matchingCategories[categories[category].faqCategoryId].length === 0)
            delete matchingCategories[categories[category].faqCategoryId];
    }
    let filteredCategories = [];
    categories.forEach((category) => {
        if (matchingCategories.hasOwnProperty(category.faqCategoryId)) {
            let updatedCategory = { ...category };
            updatedCategory.questions = matchingCategories[category.faqCategoryId];
            filteredCategories.push(updatedCategory)
        }
    });
    return filteredCategories;
}

export const findIndexOfQuestion = (questions, searchParams) => {
    let index = -1;
    for (let i in questions) {
        if (questions[i].categoryId === searchParams.categoryId && questions[i].questionId === searchParams.questionId) {
            index = parseInt(i);
            break;
        }
    }
    return index;
}

export const formatPickupDateRange = (startDate, endDate) => {
    startDate = isValid(startDate) ? startDate : new Date(startDate);
    endDate = isValid(endDate) ? endDate : new Date(endDate);

    if (isValid(startDate) && isValid(endDate)) {
        const days = dayNamesShort();
        const months = monthNamesFull();
        const formattedStartDate = days[startDate.getDay()] + ". " + months[startDate.getMonth()] + " " + startDate.getDate();

        if (format(startDate, "ddMMyyyy") === format(endDate, "ddMMyyyy")) {
            return formattedStartDate + ", " + startDate.getFullYear();
        }
        else {
            const formattedEndDate = days[endDate.getDay()] + ". " + months[endDate.getMonth()] + " " + endDate.getDate() + ", " + endDate.getFullYear();
            return formattedStartDate + " - " + formattedEndDate;
        }
    }
    return "";
}

export const formatOrderDate = (orderDate, withTime) => {
    if (!orderDate || !isValid(new Date(orderDate))) return "";
    /*const dateDetails = orderDate.split(" ");
    const orderDateData = dateDetails.length === 6 ? new Date(dateDetails[1] + " " + dateDetails[2] + ", " + dateDetails[5]) : null;

    if (!orderDateData) return "";
    return format(orderDateData, "dd.MM.yyyy");*/
    const dateExpression = COUNTRY_CODE === "BR" ? "dd.MM.yyyy" : "MM.dd.yyyy";
    const expression = withTime === true ? dateExpression + " HH:mm:ss" : dateExpression;
    return format(new Date(orderDate), expression)
}

export const getDateWithSpecificFormat = (dateValue, dateFormat) => {
    if (!dateValue || !isValid(new Date(dateValue))) return "";
    if (!dateFormat) {
        dateFormat = 'yyyy-MM-dd';
    }
    return format(new Date(dateValue), dateFormat);
}

export const transformTableDataList = config => {
    if (!config.data) return null;
    if (config.tableType && config.tableType.split("-")[0] === "drs") return drsTableDataTransform(config);

    let result = {};
    let tableData = [];
    const isCustomer = config.userType === "Customer";

    if (config.tableType === "order") {
        config.data.forEach(order => {
            let row = [];
            //const orderInProgress = order.status === "ORDERED" || order.status === "CANCEL_REQUEST_SENT";
            const orderCompleted = order.status && order.status.toUpperCase() === "COMPLETED";
            const orderPendingQuote = order.status && order.status.toUpperCase() === "PENDING_QUOTE";
            const selfOrder = config.userId === order.userId;
            const orderPlacedForSelectedCountry = order.address ? order.address.country === COUNTRY_CODE : false;

            const enableForCert = order.enableForCert;
            config.columns.forEach(column => {

                let columnValue = order.hasOwnProperty(column.id) && order[column.id];
                let displayAsIs = column.data.displayInBodyAsIs;
                let clickEventIdentifier = column.id;

                if (column.data.displayInBodyAs === "string") {
                    if (column.id === "id") {
                        columnValue = order.orderId;
                        displayAsIs = true;
                    }
                    if (column.id === "date_ordered") {
                        columnValue = order.createdDate ? getDateWithSpecificFormat(order.createdDate) : '';
                        displayAsIs = true;
                    }
                    if (column.id === "date_uploaded") {
                        columnValue = order.uploadedDate ? getDateWithSpecificFormat(order.uploadedDate) : '';
                        displayAsIs = true;
                    }
                    if (column.id === "po_date_uploaded") {
                        columnValue = order.uploadedDate ? getDateWithSpecificFormat(order.uploadedDate) : '';
                        displayAsIs = true;
                    }
                    if (column.id === "po_order_name") {
                        columnValue = order.fileName;
                        displayAsIs = true;
                    }
                    if (column.id === "po_upload_status") {
                        columnValue = order.status;
                        displayAsIs = false;
                    }
                    if (column.id === "order_name") {
                        columnValue = order.fileName;
                        displayAsIs = true;
                    }
                    if (column.id === "upload_status") {
                        columnValue = order.status;
                        displayAsIs = false;
                    }
                    if (column.id === "status") {
                        columnValue = order.status || "";
                        displayAsIs = !order.status;
                    }
                    if (column.id === "company") {
                        columnValue = order.company || "";
                        displayAsIs = true;
                    }
                    if (column.id === "address") {
                        columnValue = order.address ? transformUserAddress(order.address).join(" ") : "";
                        displayAsIs = true;
                    }
                    if (column.id === "name") {
                        let name = "";
                        if (order.firstName) {
                            name += order.firstName + " ";
                        }
                        if (order.lastName) {
                            name += order.lastName;
                        }
                        columnValue = name;
                        displayAsIs = true;
                    }
                }

                if (column.data.displayInBodyAs === "button") {
                    let buttonType = "_blank";
                    let buttonEndIcon = null;
                    let buttonTheme = null;
                    let buttonLabelId = null;
                    let buttonDisabled = false;

                    switch (column.id) {
                        case "certificate":
                            if (enableForCert) {
                                buttonType = "icon";
                                buttonEndIcon = "certificate";
                            }
                            break;
                        case "export_reports":
                        case "see_all_orders":
                            if (orderPendingQuote && selfOrder && orderPlacedForSelectedCountry) {
                                /**
                                 * show 'place order' button for only those quote orderBySet
                                 * placed by current user and for current selected country
                                 */
                                buttonLabelId = "place_order"
                                buttonType = "button";
                                buttonTheme = "white";
                            };
                            break;
                        default:
                    }

                    columnValue = {
                        type: buttonType,
                        endIcon: buttonEndIcon,
                        theme: buttonTheme,
                        labelId: buttonLabelId,
                        disabled: buttonDisabled
                    }

                    clickEventIdentifier = buttonType === "icon" ? buttonEndIcon : buttonLabelId;
                }

                if (column.data.displayInBodyAs === "buttonGroup") {
                    if (column.id === "certificate") {
                        let buttons = [];
                        const dissectedOrderData = orderDissection(order);

                        const codReportData = dissectedOrderData.downloadableReports.filter(report => report.type === "cod");
                        const serialAuditReportData = dissectedOrderData.downloadableReports.filter(report => report.type === "serialAudit");

                        if (codReportData.length) {
                            buttons.push(
                                {
                                    type: "icon",
                                    endIcon: "download_" + codReportData[0].format,
                                    iconStyle: { width: "35px", height: "35px" },
                                    labelId: "cod_download",
                                    theme: "blue",
                                    clickHandler: () => config.bodyButtonsHandler("cod", order.orderId, codReportData[0])
                                }
                            );
                        }

                        if (serialAuditReportData.length) {
                            buttons.push(
                                {
                                    type: "icon",
                                    endIcon: "download_" + serialAuditReportData[0].format,
                                    iconStyle: { width: "35px", height: "35px" },
                                    labelId: "serial_audit_download",
                                    theme: "blue",
                                    clickHandler: () => config.bodyButtonsHandler("serialAudit", order.orderId, serialAuditReportData[0])
                                }
                            );
                        }


                        columnValue = {
                            type: "buttonGroup",
                            buttons: buttons
                        }
                    }
                }


                if (column.data.displayInBodyAs === "html") {
                    let columnHTMLText = "";
                    if (column.id === "description" && order.categoryList) {
                        columnHTMLText += "<ul>";

                        /*let modifiedShippingMaterial = JSON.parse(JSON.stringify(order.shippingMaterial));
                        if (parseInt(order.serviceTypeId) > 0) {
                            modifiedShippingMaterial.sort((a, b) => parseInt(a.serviceType) - parseInt(b.serviceType))
                        }
                        
                        modifiedShippingMaterial.forEach(m => {
                            let text = "";
                            if (parseInt(m.serviceType)) {
                                const serviceName = config.labels['serviceName.' + m.serviceType];
                                text = `${serviceName} (${m.quantity} ${m.materialName})`;
                            }
                            else {
                                text = `${m.quantity} ${m.materialName}`;
                            }
                            columnHTMLText += `<li>${capitalizeText(text)}</li>`;
                        })*/

                        let modifiedCategories = JSON.parse(JSON.stringify(order.categoryList));
                        modifiedCategories.forEach(c => {
                            let text = "";
                            text = `${c.quantity} ${c.categoryName}`;
                            columnHTMLText += `<li>${capitalizeText(text)}</li>`;
                        });

                        columnHTMLText += "</ul>";
                    }

                    columnValue = columnHTMLText;
                    displayAsIs = true;
                }

                row.push({
                    [column.id]: {
                        id: column.id + "|" + order.orderId,
                        type: column.data.displayInBodyAs,
                        value: columnValue,
                        width: column.width,
                        displayAsIs: displayAsIs,
                        showInMobileViewAs: column.showInMobileViewAs,
                        clickHandler: column.data.displayInBodyAs !== "string" ? () => config.bodyButtonsHandler(clickEventIdentifier, order.orderId) : null
                    }
                });
            });

            tableData.push({
                id: order.orderId,
                data: row
            });
        });
    }

    if (config.tableType === "price_list") {
        config.data.forEach(price => {
            let row = [];
            const rowId = price.id;

            config.columns.forEach(column => {
                let columnValue = "";

                let displayAsIs = column.data.displayInBodyAsIs;

                if (column.data.displayInBodyAs === "string") {
                    if (column.id === "file_name") {
                        columnValue = price.fileName || "";
                        displayAsIs = true;
                    }

                    if (column.id === "rateCardType") {
                        columnValue = price.rateCartType || "";
                        displayAsIs = true;
                    }

                    if (column.id === "start_date") {
                        columnValue = price.startDate ? getDateWithSpecificFormat(price.startDate) : "";
                        displayAsIs = true;
                    }

                    if (column.id === "end_date") {
                        columnValue = price.endDate ? getDateWithSpecificFormat(price.endDate) : "";
                        displayAsIs = true;
                    }

                    if (column.id === "price_file_upload_status" || column.id === "exchange_rate_file_upload_status") {
                        columnValue = price.status || "";
                        displayAsIs = false;
                    }

                    if (column.id === "upload_by") {
                        columnValue = price.uploadedBy || "";
                        displayAsIs = true;
                    }

                    if (column.id === "upload_date") {
                        columnValue = price.uploadedDate ? getDateWithSpecificFormat(price.uploadedDate) : "";
                        displayAsIs = true;
                    }

                    if (column.id === "approved_by") {
                        columnValue = price.approvedBy || "";
                        displayAsIs = true;
                    }

                    if (column.id === "approved_date") {
                        columnValue = price.approvedDate ? getDateWithSpecificFormat(price.approvedDate) : "";
                        displayAsIs = true;
                    }
                }

                row.push({
                    [column.id]: {
                        id: column.id + "|" + rowId,
                        type: column.data.displayInBodyAs,
                        value: columnValue,
                        width: column.width,
                        displayAsIs: displayAsIs,
                        showInMobileViewAs: column.showInMobileViewAs
                    }
                });
            });

            tableData.push({
                id: rowId,
                data: row
            });
        });
    }

    if (config.tableType === "customer_service_price_list") {
        config.data.forEach(price => {
            let row = [];
            const rowId = price.id;

            config.columns.forEach(column => {
                let columnValue = "";
                let displayAsIs = column.data.displayInBodyAsIs;

                if (column.data.displayInBodyAs === "string") {
                    if (column.id === "rate_card") {
                        columnValue = price.fileName || "";
                        displayAsIs = true;
                    }

                    if (column.id === "start_date") {
                        columnValue = price.startDate ? getDateWithSpecificFormat(price.startDate) : "";
                        displayAsIs = true;
                    }

                    if (column.id === "end_date") {
                        columnValue = price.endDate ? getDateWithSpecificFormat(price.endDate) : "";
                        displayAsIs = true;
                    }

                    if (column.id === "updated_date") {
                        columnValue = price.updatedDate ? getDateWithSpecificFormat(price.updatedDate) : "";
                        displayAsIs = true;
                    }

                    if (column.id === "price_file_upload_status" || column.id === "exchange_rate_file_upload_status") {
                        columnValue = price.status || "";
                        displayAsIs = false;
                    }

                    if (column.id === "upload_by") {
                        columnValue = price.uploadedBy || "";
                        displayAsIs = true;
                    }

                    if (column.id === "upload_date") {
                        columnValue = price.uploadedDate ? getDateWithSpecificFormat(price.uploadedDate) : "";
                        displayAsIs = true;
                    }

                    if (column.id === "expiration_date") {
                        columnValue = price.expirationDate ? getDateWithSpecificFormat(price.expirationDate) : "";
                        displayAsIs = true;
                    }

                    if (column.id === "org_id") {
                        columnValue = price.orgId || "";
                        displayAsIs = true;
                    }

                    if (column.id === "customer_service_companyname") {
                        columnValue = price.companyName || "";
                        displayAsIs = true;
                    }

                }

                row.push({
                    [column.id]: {
                        id: column.id + "|" + rowId,
                        type: column.data.displayInBodyAs,
                        value: columnValue,
                        width: column.width,
                        displayAsIs: displayAsIs,
                        showInMobileViewAs: column.showInMobileViewAs
                    }
                });
            });

            tableData.push({
                id: rowId,
                data: row
            });
        });
    }

    const { addressList = [], isDirectCustomerBillingAddress = false } = config.data;

    if (config.tableType === "address") {
        addressList.forEach(address => {
            let row = [];
            const rowId = address.addressId;
            config.columns.forEach(column => {
                let columnValue = address.hasOwnProperty(column.id) && address[column.id];

                let displayAsIs = column.data.displayInBodyAsIs;
                let clickEventIdentifier = column.id;

                if (column.data.displayInBodyAs === "string") {
                    if (column.id === "addressType") {
                        columnValue = address.addressType || "";
                        displayAsIs = true;
                    }
                    if (column.id === "address") {
                        columnValue = transformUserAddress(address).join(", ");
                        displayAsIs = true;
                    }
                }

                if (column.data.displayInBodyAs === "buttonGroup") {
                    let buttons = [];
                    if (column.id === "actions") {
                        buttons.push(
                            {
                                type: "icon",
                                endIcon: "edit",
                                iconStyle: { width: "20px", height: "20px" },
                                labelId: "edit",
                                clickHandler: () => config.bodyButtonsHandler("edit", rowId)
                            }
                        );
                        if (!isDirectCustomerBillingAddress) {
                            buttons.push(
                                {
                                    type: "icon",
                                    endIcon: "delete",
                                    iconStyle: { width: "20px", height: "20px" },
                                    labelId: "delete",
                                    clickHandler: () => config.bodyButtonsHandler("delete", rowId)
                                }
                            );
                        }
                    }

                    columnValue = {
                        type: "buttonGroup",
                        buttons: buttons
                    }
                }

                row.push({
                    [column.id]: {
                        id: column.id + "|" + rowId,
                        type: column.data.displayInBodyAs,
                        value: columnValue,
                        width: column.width,
                        displayAsIs: displayAsIs,
                        showInMobileViewAs: column.showInMobileViewAs,
                        clickHandler: column.data.displayInBodyAs !== "string" ? () => config.bodyButtonsHandler(clickEventIdentifier, rowId) : null
                    }
                });
            });

            tableData.push({
                id: rowId,
                data: row
            });
        });
    }

    const { contactList = [] } = config.data;

    if (config.tableType === "contact") {
        contactList.forEach(contact => {
            let row = [];
            const rowId = contact.contactId;
            config.columns.forEach(column => {
                let columnValue = contact.hasOwnProperty(column.id) && contact[column.id];

                let displayAsIs = column.data.displayInBodyAsIs;
                let clickEventIdentifier = column.id;

                if (column.data.displayInBodyAs === "string") {
                    if (column.id === "contact") {
                        columnValue = transformContact(contact);
                        displayAsIs = true;
                    }
                }

                if (column.data.displayInBodyAs === "buttonGroup") {
                    let buttons = [];
                    if (column.id === "actions") {
                        buttons.push(
                            {
                                type: "icon",
                                endIcon: "edit",
                                iconStyle: { width: "20px", height: "20px" },
                                labelId: "edit",
                                clickHandler: () => config.bodyButtonsHandler("edit", rowId)
                            }
                        );
                        buttons.push(
                            {
                                type: "icon",
                                endIcon: "delete",
                                iconStyle: { width: "20px", height: "20px" },
                                labelId: "delete",
                                clickHandler: () => config.bodyButtonsHandler("delete", rowId)
                            }
                        );
                    }

                    columnValue = {
                        type: "buttonGroup",
                        buttons: buttons
                    }
                }

                row.push({
                    [column.id]: {
                        id: column.id + "|" + rowId,
                        type: column.data.displayInBodyAs,
                        value: columnValue,
                        width: column.width,
                        displayAsIs: displayAsIs,
                        showInMobileViewAs: column.showInMobileViewAs,
                        clickHandler: column.data.displayInBodyAs !== "string" ? () => config.bodyButtonsHandler(clickEventIdentifier, rowId) : null
                    }
                });
            });

            tableData.push({
                id: rowId,
                data: row
            });
        });
    }

    result['columns'] = config.columns;
    result['data'] = tableData;

    return result;

}

export const prepareAddressData = (userProfileData, index, nextAvailableAddressTypeIndex, addressLabel) => {
    let addressData = {};

    if (REGION_CODE === "APJ") {
        const addressTypeKey = "address" + index;
        addressData.addressType = userProfileData[addressTypeKey] && userProfileData[addressTypeKey].addressType ? userProfileData[addressTypeKey].addressType : "";
    }
    else {
        addressData.addressType = userProfileData['address' + index] ? (userProfileData['address' + index].addressType ? userProfileData['address' + index].addressType : (addressLabel + " " + nextAvailableAddressTypeIndex)) : (addressLabel + " " + nextAvailableAddressTypeIndex);
    }

    addressData.addressLine1 = userProfileData['address' + index] ? (userProfileData['address' + index].addressLine1 ? userProfileData['address' + index].addressLine1 : "") : "";
    addressData.addressLine2 = userProfileData['address' + index] ? (userProfileData['address' + index].addressLine2 ? userProfileData['address' + index].addressLine2 : "") : "";
    addressData.city = userProfileData['address' + index] ? (userProfileData['address' + index].city || "") : "";
    addressData.country = userProfileData['address' + index] ? (userProfileData['address' + index].country || "") : "";
    addressData.state = userProfileData['address' + index] ? (userProfileData['address' + index].state || "") : "";
    addressData.zipCode = userProfileData['address' + index] ? (userProfileData['address' + index].zipCode || "") : "";
    addressData.streetType = userProfileData['address' + index] ? (userProfileData['address' + index].streetType || "") : "";
    addressData.streetNumber = userProfileData['address' + index] ? (userProfileData['address' + index].streetNumber || "") : "";
    addressData.streetName = userProfileData['address' + index] ? (userProfileData['address' + index].streetName || "") : "";
    addressData.floor = userProfileData['address' + index] ? (userProfileData['address' + index].floor || "") : "";
    addressData.staircase = userProfileData['address' + index] ? (userProfileData['address' + index].staircase || "") : "";
    addressData.door = userProfileData['address' + index] ? (userProfileData['address' + index].door || "") : "";
    return addressData;
}
export const transformQuesDataForSurveyResponse = (questionaire) => {
    /** expected data...
     * "questionaire": [{
            "questionType": "rating",
            "question": "Question 1"
        }, {
            "questionType": "comment",
            "question": "Question 2"
        }, {
            "questionType": "both",
            "question": "Question 3"
        }]
     */
    /**
     * return format...
     * [
            {
                "question": "Question 1",
                "rating": ""
            },
            {
                "question": "Question 2",
                "comment": ""
            },
            {
                "question": "Question 3",
                "rating": ""
                "comment": ""
            }
        ]
    */
    return questionaire.map((questionData) => {
        return {
            question: questionData.question,
            ...(questionData.questionType === "rating") && { rating: "" },
            ...(questionData.questionType === "comment") && { comment: "" },
            ...(questionData.questionType === "both") && { rating: "", comment: "" }
        };
    });
}

export const groupCategoriesByType = (categories, singleGroup) => {
    let types = singleGroup ? ["all"] : [];
    let result = [];

    !singleGroup && categories.forEach(category => types.indexOf(category.categoryType) === -1 && types.push(category.categoryType));

    types.forEach(type => {
        result.push({
            [type]: categories.filter(category => singleGroup ? category : category.categoryType === type)
        })
    });
    return result;
}

export const validateUserMaterialSelection = materialData => {
    if (!materialData) return null;

    //let valid = false;
    let quantityGrandTotal = 0;
    let allMaterials = [];
    let validMaterials = [];
    let validMaterialCodes = [];
    let invalidMaterials = [];
    let invalidMaterialsWithWeight = [];
    let serviceTypeQuantities = [];

    for (let i = 0; i < materialData.length; i++) {
        const currentMaterialType = materialData[i];
        const maxPerOrder = currentMaterialType.maxPerOrder;
        const boxService = currentMaterialType.boxService;
        allMaterials.push(currentMaterialType.id);

        let totalQuantityOfCurrentType = 0;
        for (let j = 0; j < currentMaterialType.materials.length; j++) {
            const currentMaterial = currentMaterialType.materials[j];
            const quantity = parseInt(currentMaterial.quantity);
            const hasWeight = currentMaterial.hasOwnProperty("weight");

            if (quantity) {
                validMaterials.indexOf(currentMaterialType.id) === -1 && validMaterials.push(currentMaterialType.id);
                validMaterialCodes.push(currentMaterial.id);

                (hasWeight && !currentMaterial.weight) && invalidMaterialsWithWeight.push(currentMaterial.id);
            }

            quantityGrandTotal += quantity;
            totalQuantityOfCurrentType += quantity;

            if (currentMaterial.serviceType) {
                const serviceTypeIndex = getIndex(serviceTypeQuantities, "id", currentMaterial.serviceType);
                if (serviceTypeIndex === -1) {
                    serviceTypeQuantities.push({
                        id: currentMaterial.serviceType,
                        quantity: quantity
                    })
                }
                else {
                    serviceTypeQuantities[serviceTypeIndex].quantity += quantity;
                }
            }
        }

        const invalidServiceTypeQuantities = serviceTypeQuantities.filter(service => service.quantity > maxPerOrder);

        if (
            (!boxService && maxPerOrder && totalQuantityOfCurrentType > maxPerOrder) ||
            (boxService && maxPerOrder && invalidServiceTypeQuantities.length)
        ) {
            invalidMaterials.push({
                type: currentMaterialType.id,
                maxPerOrder: maxPerOrder,
                ...(boxService) && {
                    serviceId: invalidServiceTypeQuantities.length === 1 ? invalidServiceTypeQuantities[0].id : 3
                }
            });
        }
    }

    return {
        error: (quantityGrandTotal === 0 || invalidMaterials.length !== 0 || invalidMaterialsWithWeight.length !== 0),
        quantityGrandTotal: quantityGrandTotal,
        allMaterials: allMaterials,
        validMaterials: validMaterials,
        validMaterialCodes: validMaterialCodes,
        invalidMaterials: invalidMaterials,
        invalidMaterialsWithWeight: invalidMaterialsWithWeight
    };
}

export const transformOrderDataForRepeatOrder = orderDetails => {
    const {
        orderType = 0,
        serviceTypeId = 0,
        categoryList = [],
        shippingMaterial = [],
        address = null
    } = orderDetails;

    if (!orderType) return false;

    let result = {};
    const orderTypeId = orderType;
    const orderOptions = AppConfigData.order_options[orderTypeId];
    const repeatOrderStartStep = "order-summary";

    result.repeatOrder = true;
    result.orderType = parseInt(orderTypeId);
    result.serviceSelectionRequired = Boolean(serviceTypeId);
    result.serviceType = serviceTypeId || 0;
    result.currentStep = orderOptions.checkout_steps.indexOf(repeatOrderStartStep) + 1;

    const selectedCategories = [];
    categoryList.forEach(category => {
        selectedCategories.push({
            categoryId: category.categoryId,
            quantity: category.quantity,
            categoryName: category.categoryName
        });
    });
    result.selectedCategories = selectedCategories;

    const selectedMaterials = transformMaterialsData({ list: shippingMaterial }, orderTypeId);
    result.selectedMaterials = selectedMaterials;
    result.materialsValidityData = validateUserMaterialSelection(selectedMaterials);

    const additionalAddressFields = getAddressFieldsList(address.country);
    additionalAddressFields.forEach(addressField => {
        if (orderDetails.hasOwnProperty(addressField) && !address.hasOwnProperty(addressField)) {
            address[addressField] = orderDetails[addressField]
        }
    });
    address.formValid = true;
    result.addressData = address;

    return {
        data: result,
        path: "recycle/" + orderOptions.route + "/" + repeatOrderStartStep
    };
}

export const getPostalCodePrefixes = (stateId, country) => {
    const countryCode = country ? country : COUNTRY_CODE;
    const stateData = getStateDataByStateId(stateId, countryCode);
    if (stateData) {
        return stateData.postal_code_prefixes;
    }
    else {
        return [];
    }
}

export const transformUserAddress = (data, messages) => {
    if (!data) return [];

    const { addressLine1 = "", streetName = "", streetNumber = "", addressLine2 = "", floor = "", staircase = "", door = "", city = "", state = "", zipCode = "", country = "", company = "", contactNo = "" } = data;
    const optionalAddressFields = [
        { id: "floor", value: floor },
        { id: "staircase", value: staircase },
        { id: "door", value: door }
    ];

    /*let line1 = (streetName && streetNumber) ? streetName.trim() + ", " + streetNumber : addressLine1;

    if (addressLine2) {
        line1 += ", " + addressLine2;
    }*/
    let line1 = "";
    if (company) line1 += company;

    let line2 = "";
    if (streetName) line2 += streetName + ", ";
    if (addressLine1) line2 += addressLine1;
    if (streetNumber) line2 += " " + streetNumber;
    if (addressLine2) line2 += ", " + addressLine2;


    let line3 = "";
    if (messages) {
        optionalAddressFields.filter(addrObj => addrObj.value).forEach((addrProp, i, arr) => {
            if (addrProp.value) {
                const propLabel = messages ? messages['form.fields.label.' + addrProp.id] : null;
                line3 += propLabel ? propLabel + " " + addrProp.value : addrProp.value;
                if (i < arr.length - 1) line3 += ", ";
            }
        })
    }

    let line4 = city;
    if (state) {
        line4 += ", " + state;
    }
    line4 += " " + zipCode;

    let line5 = getCountryNameByCountryCode(country, LANG);

    let line6 = "";
    if (contactNo) line6 += contactNo;

    const result = [line1, line2, line3, line4, line5, line6].filter(line => line);
    return result;
}
export const transformContact = (data) => {
    if (!data) return [];
    const { firstName = "", lastName = "", phone = "", email = "" } = data;
    const contactDetails = `${firstName} ${lastName}, ${phone}, ${email}`;

    return contactDetails;
}

export const checkIfCancellationIsAllowed = (orderType, serviceType, materialsValidityData) => {
    if (!materialsValidityData) return false;

    let isCancellationAllowed = false;

    if (REGION_CODE === "AMS") {
        // for NA, cancellation is allowed only for non-label orders
        if (!(materialsValidityData.validMaterials.length === 1 && materialsValidityData.validMaterials[0] === "label")) {
            isCancellationAllowed = true;
        }
    }

    if (REGION_CODE === "EMEA") {
        if (serviceType === 0) {
            // For Mail it Back orders
            const materialsNotAllowedForCancellation = ["envelope", "label"];
            isCancellationAllowed = materialsValidityData.validMaterials.filter(material => materialsNotAllowedForCancellation.indexOf(material) === -1).length !== 0;
        }
        else {
            // For box services, cancellation is allowed for delivery service for all countries
            // for collection or delivery+collection services, cancellation is allowed for 
            // all countries except Spain and France

            if (serviceType === 1 || serviceType === 3) {
                isCancellationAllowed = true;
            }
            if (serviceType === 2) {
                if (COUNTRY_CODE !== "ES" && COUNTRY_CODE !== "FR") {
                    isCancellationAllowed = true;
                }
            }
        }
    }

    if (REGION_CODE === "APJ") {
        // to do - set rules for cancellation
        isCancellationAllowed = true;
    }

    if (REGION_CODE === "AMS") {
        // to do - set rules for cancellation
        isCancellationAllowed = true;
    }

    return isCancellationAllowed;
}

export const detectOrderTypeFromPathName = pathName => {
    const allOrderOptions = AppConfigData.order_options;
    for (let orderTypeId in allOrderOptions) {
        const orderOptions = allOrderOptions[orderTypeId];
        if (pathName.indexOf(orderOptions.route) !== -1) {
            return allOrderOptions[orderTypeId].order_type_id;
        }
    }
    return 0;
}

export const transformCategoryQuantityRange = quantities => {
    let minQuantity = 0
    let maxQuantity = 0;
    minQuantity = quantities && (quantities[0].lowerLimit || quantities[0].upperLimit);
    maxQuantity = quantities && (quantities[quantities.length - 1].upperLimit || quantities[quantities.length - 1].lowerLimit);

    return {
        min: minQuantity,
        max: maxQuantity
    }
}

export const categoryDetailsWithRange = categories => {
    let result = "<ul>";
    categories.forEach(category => {
        if (category.error) {
            const range = transformCategoryQuantityRange(category.quantities);
            result += "<li>" + category.categoryName + " (" + range.min + "-" + range.max + ")</li>";
        }
    })

    result += "</ul>";

    return result;
}

export const getToBeClearedMaterialsList = ({ allAvailableMaterials, selectedMaterialType, materialUpdateRules }) => {
    let result = [];

    if (materialUpdateRules.clearAllOfOtherType) {
        result = allAvailableMaterials.filter(m => m.id !== selectedMaterialType);
    }

    if (materialUpdateRules.clearAllOfSameType) {
        result = allAvailableMaterials.filter(m => m.id === selectedMaterialType);
    }

    if (materialUpdateRules.cannotBeMixedWithOtherTypes) {
        const targetMaterial = materialUpdateRules.cannotBeMixedWithOtherTypes;
        if (targetMaterial === selectedMaterialType) {
            result = allAvailableMaterials.filter(m => m.id !== targetMaterial);
        }
        else {
            result = allAvailableMaterials.filter(m => m.id === targetMaterial);
        }
    }

    return result;
}

export const hazardousItemsExistIn = list => {
    for (let i = 0; i < list.length; i++) {
        const category = list[i];
        if (category.hasOwnProperty("isHazardous") && category.isHazardous === true) {
            return true;
        }
    }
    return false;
}

export const materialUpdateRulesApplicable = rules => {
    for (const rule in rules) {
        if (rules[rule]) return true;
    }
    return false;
}

export const getAddressFieldsList = country => {
    const list = [];
    if (addressFormMatrix) {
        for (const field in addressFormMatrix) {
            if (addressFormMatrix[field].includes(country)) {
                list.push(field);
            }
        }
    }

    return list;
}

export const orderAppliesToCurrentUser = orderConfig => {
    let applies = true;

    if (orderConfig.disabledInCountries && orderConfig.disabledInCountries.length && orderConfig.disabledInCountries.includes(COUNTRY_CODE)) {
        applies = false;
    }

    if (BUSINESS_LANDING) {
        if (orderConfig.hasOwnProperty("appliesOnlyToBusiness") && orderConfig.appliesOnlyToBusiness === false) {
            applies = false;
        }
    }
    else {
        if (orderConfig.hasOwnProperty("appliesOnlyToBusiness") && orderConfig.appliesOnlyToBusiness === true) {
            applies = false;
        }
    }

    return applies;
}


export const getModifiedSelectedCategoriesList = ({
    selectedCategories = null,
    catalogCategories = null,
    otherCategoryWeight = 0
}) => {
    if (!selectedCategories || !catalogCategories) return null;

    const modifiedSelectedCategoriesList = [];
    const otherCategory = catalogCategories.filter(c => c.categoryType === "others");
    selectedCategories.forEach(c => {
        const categoryData = { categoryId: c.categoryId, quantity: c.quantity };
        if (otherCategory.length && (c.categoryId === otherCategory[0].categoryId)) {
            categoryData.weight = otherCategoryWeight;
        }
        modifiedSelectedCategoriesList.push(categoryData);
    });

    return modifiedSelectedCategoriesList;
}

export const getConfigDataFromCategories = (categoryList, messages) => {
    if (!categoryList.length) return [];

    const getLabel = (parentId, labelId) => messages["drs.checkout.landing.config." + parentId + "." + labelId] || labelId;

    let uniqueCategories = [];
    let categoryConfigOptions = {};
    categoryList.forEach(category => {
        if (!categoryConfigOptions[category.categoryId]) {
            const configData = {};
            for (let prop in category) {
                if (Array.isArray(category[prop])) {
                    const configOptionsData = [];

                    category[prop].forEach(item => {
                        configOptionsData.push({ id: item, label: getLabel(prop, item) });
                    });

                    configData[prop] = configOptionsData;
                }
            }

            categoryConfigOptions[category.categoryId] = configData;
            uniqueCategories.push({ id: category.categoryId, assetType: category.assetType, label: getLabel("assetType", category.assetType) });
        }
    });

    return {
        uniqueCategories: uniqueCategories,
        categoryConfigOptions: categoryConfigOptions
    }
}

export const getInitialConfigSelections = ({ categoryId, assetType, categoryOptions }) => {
    if (!categoryOptions) return null;

    const result = {};
    result.categoryId = categoryId;
    result.assetType = assetType;
    result.quantity = 0;
    for (let prop in categoryOptions) {
        result[prop] = categoryOptions[prop][0]?.id
    }

    return result;
}

export const transformAssetData = (asset, messages) => {
    let result = "";

    let { brand = "", assetType = "", processorType = "", screenSize = "" } = asset;

    if (brand) {
        brand = messages["drs.checkout.landing.config.brand." + brand] || brand;
    }

    if (assetType) {
        assetType = messages["drs.checkout.landing.config.assetType." + assetType] || assetType;
    }

    if (processorType) {
        processorType = messages["drs.checkout.landing.config.processorType." + processorType] || processorType;
    }

    if (brand) {
        result += brand + ",";
    }

    if (assetType) {
        result += " " + assetType + ",";
        if ((assetType === 'Monitor' || assetType === 'monitor') && screenSize) {
            result += " " + screenSize + " inches";
            console.log('Monitor Result is : ' + result);
        }
        else if ((assetType === 'Tablet' || assetType === 'tablet') && screenSize) {
            result += " " + screenSize + " inches,";
            console.log('Tablet Result is : ' + result);
        }
    }

    if (processorType) {
        result += " " + processorType + ",";
    }

    if (result[result.length - 1] === ",") {
        result = result.slice(0, -1);
    }

    return result;

}

export const transformCountryVendorData = (rawData) => {
    //todo - method can be refactored
    // Removes duplicate items from the list
    const uniqueCountryVendors = [...new Map(rawData.countryVendors.map(item => [item["countryCode"], item])).values()]
    let transformedCountryVendorData = uniqueCountryVendors.map((countryItem) => {
        let obj = {};
        obj.country = {
            countryCode: countryItem.countryCode,
            value: true
        };
        obj.vendors = [];
        countryItem.vendors.map(vendor => {
            obj.vendors.push({
                vendorName: vendor.vendorName,
                value: {
                    type: vendor.revitalize ? "REVITALIZE" : "AVAILABLE",
                    revitalize: vendor.revitalize
                }
            })
        })
        return obj;
    })
    return transformedCountryVendorData;
}

export const reverseTransformCountryVendorData = (transformedVendorData) => {
    let rawData = []
    transformedVendorData.forEach(countryData => {
        rawData.push({
            countryCode: countryData.country.countryCode,
            vendors: countryData.vendors.filter(vendor => vendor.value).map(vendor => vendor.vendorName)
        })
    })
    return rawData;
}

const getRevitalizeVendors = (vendorData) => {
    let revitalizeVendors = []
    vendorData.map(country => {
        let vendorRevitalizeData = {}
        vendorRevitalizeData.country = country.countryCode;
        country.vendors.map(vendor => {
            if (vendor.revitalize === true) {
                vendorRevitalizeData.vendors = []
                vendorRevitalizeData.vendors.push(vendor)
                revitalizeVendors.push(vendorRevitalizeData)
            }
        })
    })

    return revitalizeVendors
}

const getUpdatedRevitalizeVendors = (vendorData) => {
    let revitalizeVendors = []
    vendorData.map(country => {
        country.vendors.map(vendor => {
            if (vendor.value.type === "REVITALIZE") {
                revitalizeVendors.push(vendor)
            }
        })
    })

    return revitalizeVendors;
}

export const transformCountryVendorDataRevitalize = (rawData, isRevitalize) => {
    const uniqueCountryVendors = [...new Map(rawData.countryVendors.map(item => [item["countryCode"], item])).values()]

    let transformedCountryVendorData = uniqueCountryVendors.map((countryItem) => {
        let obj = {};
        let filterVendors = [];
        obj.vendors = [];

        obj.country = {
            countryCode: countryItem.countryCode,
            value: true
        };

        filterVendors = rawData?.countryVendors.filter(vendor => vendor.countryCode === countryItem.countryCode)[0]

        filterVendors?.vendors.forEach(vendor => {
            let vendorData = {
                vendorName: vendor.vendorName,
                value: {
                    type: (isRevitalize === 'DRS_REVITALIZE' && vendor.revitalize) ? "REVITALIZE" : "AVAILABLE",
                    revitalize: isRevitalize === 'DRS_REVITALIZE' ? vendor.revitalize : false,
                    disabled: false
                }
            }
            if (getRevitalizeVendors(uniqueCountryVendors).length === 1 && vendor.revitalize === true) {
                vendorData.value.disabled = true
            }
            obj.vendors.push(vendorData)
        })
        return obj;
    })
    return transformedCountryVendorData;
}
export const transformUpdatedCountryVendorData = (data) => {
    let filteredData = data.map(vendorsList => {
        let obj = {}
        obj.vendors = [];
        obj.country = {
            countryCode: vendorsList.country.countryCode,
            value: vendorsList.country.value
        };
        obj.vendors = vendorsList.vendors.map(vendor => {
            return {
                vendorName: vendor.vendorName,
                value: {
                    type: vendor.value.type,
                    revitalize: vendor.value.revitalize,
                    disabled: getUpdatedRevitalizeVendors(data).length === 1 && vendor.value.type === "REVITALIZE" && vendor.value.revitalize === true
                }
            }
        })
        return obj
    })
    return filteredData
}
export const reverseTransformCountryVendorDataRevitalize = (transformedVendorData) => {
    let rawData = []
    transformedVendorData.forEach(countryData => {
        let selectedVendor = {};
        selectedVendor.vendors = []
        selectedVendor.countryCode = countryData.country.countryCode;
        countryData.vendors.map(vendor => {
            if (vendor.value.type === 'AVAILABLE' || vendor.value.type === 'REVITALIZE') {
                selectedVendor.vendors.push({
                    vendorName: vendor.vendorName,
                    revitalize: vendor.value.type === 'REVITALIZE'
                })
            }
        })
        rawData.push(selectedVendor)
    })
    return rawData;
}